'use client';

import { FC } from 'react';

import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';

interface Props {
   fullName: string;
   languageCode: string;
}

export const LegalEntityInfoLanguageButton: FC<Props> = ({ fullName, languageCode }) => {
   const scrollToInfo = () => {
      document.getElementById(`entity-${languageCode}`)?.scrollIntoView({ behavior: 'smooth' });
   };

   return (
      <Button variant="primary" trailingIcon="arrow-down" onClick={scrollToInfo}>
         {fullName}
      </Button>
   );
};
